import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Card, Col, Container, Row, Form, Button, Modal} from "react-bootstrap";
import {Link} from "react-router-dom";
import TableContainer from "Common/TableContainer";
import 'react-toastify/dist/ReactToastify.css';
import {DeleteModal} from "Common/DeleteModal";
import {
    getColorsList as onGetColorsList,
    addColorsList as onAddColorsList,
    updateColorsList as onUpdateColorsList,
    deleteColorsList as onDeleteColorsList
} from "slices/color/thunk";
import {searchColorsList} from "helpers/helper";
import {useDispatch, useSelector} from "react-redux";
import {ToastContainer} from "react-toastify";
import {createSelector} from "reselect";
import {useFormik} from "formik";
import * as Yup from "yup";

const ProductColor = () => {

    document.title = "Colors list";
    const dispatch = useDispatch<any>();

    const selectColorsList = createSelector(
        (state: any) => state.Colors,
        (colors) => ({
            colorsList: colors.colorsList
        })
    );

    const {colorsList} = useSelector(selectColorsList);
    console.log(colorsList)
    useEffect(() => {
        dispatch(onGetColorsList());
    }, [dispatch]);

    const [listView, setListView] = useState<any>();
    const [colorsLists, setColorsLists] = useState<any>(null);
    const [addColors, setAddColors] = useState<boolean>(false);
    const [editColors, setEditColors] = useState<boolean>(false);
    const [show, setShow] = useState<boolean>(false);
    const [edit, setEdit] = useState<any>();
    //add
    const handleCloseColors = () => {
        setAddColors(false);
    }
    const handleShowColors = () => setAddColors(true);
    //edit
    const handleEdit = useCallback((item: any) => {
        const lastItem = item.row.original
        setAddColors(true);
        setEditColors(true);
        setEdit({
            id: lastItem.id,
            name: lastItem.name,
            colorPicker: lastItem.heh,
        });
        console.log(lastItem)

    }, []);

    //search
    const handleChange = async (ele: any) => {
        const search = ele.target.value;
        if (search) {
            try {
                const response: any = await searchColorsList({keyword: search}, {page: 0, size: 500});
                setListView(response.content);
            } catch (error) {
                setListView([]);
            }
        } else {
            setListView(colorsList.content);
        }
    };

    // delete
    const handleDeleteShow = (ele: any) => {
        setShow(true);
        setColorsLists(ele);
    };

    const handleDeleteClose = () => {
        setShow(false);
    }

    //delete modal
    const deleteModalFunction = () => {
        const deleteData = colorsLists.row.original.id || {};
        console.log(deleteData);
        if (deleteData) {
            dispatch(onDeleteColorsList(deleteData));
        }
        setShow(false);
    };

    useEffect(() => {
        setListView(colorsList.content);
    }, [colorsList]);

    //columns
    const columns = useMemo(
        () => [
            {
                header: (
                    <Form.Check>
                        <Form.Check.Input type="checkbox" value="option" id="checkAll"/>
                        <Form.Check.Label htmlFor="checkAll"></Form.Check.Label>
                    </Form.Check>
                ),
                cell: (cell: any) => {
                    return (
                        <Form.Check className="checkbox-product-list">
                            <Form.Check.Input type="checkbox" value="2" id="checkbox-2"/>
                            <Form.Check.Label htmlFor="checkbox-2"></Form.Check.Label>
                        </Form.Check>
                    );
                },
                id: "#",
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: "№",
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cell: any) => {
                    return (
                        <span>{cell.row.index + 1}</span>
                    )
                }
            },
            {
                header: "Images",
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cell: any) => {
                    return (
                        <div className={`w-50 color-picker border`} style={{backgroundColor: `${cell.row.original.heh}`}}>
                        </div>
                    )
                }
            },
            {
                header: "Colors name",
                accessorKey: "name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Created At",
                accessorKey: "createdAt",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Updated At",
                accessorKey: "updatedAt",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Action",
                enableColumnFilter: false,
                enableSorting: false,
                cell: (cell: any) => {
                    return (
                        <ul className="d-flex gap-2 list-unstyled mb-0">
                            <li>
                                <Link to="#" className="btn btn-subtle-secondary btn-icon btn-sm edit-item-btn"
                                      onClick={() => handleEdit(cell)}><i className="ph-pencil"></i></Link>
                            </li>
                            <li className={"mx-2"}>
                                <Link to="#" className="btn btn-subtle-danger btn-icon btn-sm remove-item-btn"
                                      onClick={() => handleDeleteShow(cell)}><i className="ph-trash"></i></Link>
                            </li>
                        </ul>
                    );
                }
            },
        ], []
    );


    // validation
    const formik: any = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: (edit && edit.name) || '',
            id: edit && edit.id,
            colorPicker: (edit && edit.colorPicker) || '#364574',
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Please Enter color"),
            colorPicker: Yup.string().required("Please select a color"),
        }),

        onSubmit: (values: any) => {

            if (editColors) {

                const colorData: any = {
                    name: values.name,
                    heh: values.colorPicker,
                    id: values.id
                }

                dispatch(onUpdateColorsList(colorData));
                formik.resetForm();
            } else {
                const colorData: any = {
                    name: values.name,
                    heh: values.colorPicker,
                }
                console.log(colorData)
                dispatch(onAddColorsList(colorData));
                formik.resetForm();
            }
            if (values === null) {
                handleShowColors();
            } else {
                setEdit(null);
                setEditColors(false);
                handleCloseColors();
            }
        }
    });

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>

                    <Row id="colorsList">
                        <Col lg={12}>
                            <Card>
                                <Card.Header>
                                    <Row className="align-items-center g-2">
                                        <Col lg={3} className="me-auto">
                                            <h6 className="card-title mb-0">Colors List</h6>
                                        </Col>
                                        <Col xl={2} md={3}>
                                            <div className="search-box">
                                                <Form.Control
                                                    type="text" className="search"
                                                    placeholder="Search color..."
                                                    onChange={(e: any) => handleChange(e)}
                                                />
                                                <i className="ri-search-line search-icon"></i>
                                            </div>
                                        </Col>
                                        <Col className="col-md-auto">
                                            <div className="hstack gap-2">
                                                <Button className="btn btn-subtle-danger d-none" id="remove-actions">
                                                    <i className="ri-delete-bin-2-line"></i>
                                                </Button>
                                                <Button variant="secondary" onClick={handleShowColors}>
                                                    <i className="bi bi-plus-circle align-baseline me-1"></i> Add
                                                    Color
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Header>
                                <Card.Body className="mt-3">
                                    {
                                        listView && listView.length > 0 ?
                                            <TableContainer
                                                isPagination={true}
                                                columns={columns}
                                                data={listView || []}
                                                customPageSize={10}
                                                divClassName="table-responsive table-card"
                                                tableClass="table table-centered align-middle table-custom-effect table-nowrap mb-0"
                                                theadClass="table-light"
                                                PaginationClassName="align-items-center mt-4 pt-3"
                                                isBordered={false}
                                            />
                                            :
                                            <div id="noresult">
                                                <div className="text-center py-4">
                                                    <div className="avatar-md mx-auto mb-4">
                                                        <div
                                                            className="avatar-title bg-primary-subtle text-primary rounded-circle fs-5xl">
                                                            <i className="bi bi-search"></i>
                                                        </div>
                                                    </div>
                                                    <h5 className="mt-2">Sorry! No Result Found</h5>
                                                </div>
                                            </div>
                                    }
                                </Card.Body>
                            </Card>
                        </Col>

                    </Row>
                </Container>
            </div>
            <DeleteModal show={show} handleClose={handleDeleteClose} deleteModalFunction={deleteModalFunction}/>

            <Modal show={addColors} onHide={handleCloseColors}>
                <Modal.Header closeButton>
                    <Modal.Title>{editColors ? "update Colors List" : "Add Colors"}</Modal.Title>
                </Modal.Header>
                <Form autoComplete="off" onSubmit={formik.handleSubmit}>
                    <Modal.Body>
                        <div className="mb-4">
                            <Form.Label htmlFor="Customer-Name-input">Color Name<span
                                className="text-danger">*</span></Form.Label>
                            <Form.Control
                                type="text"
                                id="Customer-Name-input"
                                name="name"
                                placeholder="Color Name"
                                value={formik.values.name}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={!!formik.errors.name}
                            />
                            {formik.errors.name && formik.touched.name ? (
                                <Form.Control.Feedback type="invalid">{formik.errors.name}</Form.Control.Feedback>
                            ) : null}
                        </div>

                        <div className="mb-3">
                            <Form.Group>
                                <Form.Label>Color Picker</Form.Label>
                                <Form.Control
                                    type="color"
                                    className="form-control form-control-color w-100"
                                    id="colorPicker"
                                    name="colorPicker"
                                    value={formik.values.colorPicker}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    isInvalid={!!formik.errors.colorPicker}
                                />
                            </Form.Group>

                            {formik.errors.colorPicker && formik.touched.colorPicker ? (
                                <Form.Control.Feedback type="invalid">{formik.errors.colorPicker}</Form.Control.Feedback>
                            ) : null}

                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" className="btn btn-ghost-danger" onClick={handleCloseColors}>
                            <i className="bi bi-x-lg align-baseline me-1"></i> Close
                        </Button>
                        <Button type="submit" variant="primary"
                                id="add-btn">{editColors ? "update" : "Add Color"}</Button>
                    </Modal.Footer>
                </Form>
            </Modal>
            <ToastContainer/>
        </React.Fragment>
    );
};

export default ProductColor;